import { IModel, Model } from './model'

export interface IUser extends IModel {
  email: string | null
  name: string | null
  firstName: string | null
  username: string | null
  registeredAt: string | null
  token: string | null
  meta: UserMeta | null
}

export class User extends Model implements IUser {
  public email: string | null = null
  public name: string | null = null
  public firstName: string | null = null
  public username: string | null = null
  public registeredAt: string | null = null
  public token: string | null = null
  public meta: UserMeta = new UserMeta()
}

export class UserMeta {
  public numFollowers: number = 0
  public isFollowed: boolean = false
  public numFollowing: number = 0
  public isFollowing: boolean = false
  public convoMap: Map<number, boolean> = new Map<number, boolean>()
}
